import { NoPermissionsPage } from '@arc/frontend/ui-common';
import { Can } from './Can';
export function CanRoute({
  I,
  a,
  Component
}) {
  return <Can I={I} a={a} passThrough>
			{can => can ? <Component /> : <NoPermissionsPage />}
		</Can>;
}